<template>
<div class="chapter">
<div class="inner_page">
<p class="toch"><b>Contents</b></p>
<p class="toc1" id="title"><span href="#/9781569479674_Split1#title" title="Link target outside of Sample">TITLE PAGE</span></p>
<p class="toc1" id="cop"><span href="#/9781569479674_Split3#cop" title="Link target outside of Sample">COPYRIGHT PAGE</span></p>
<p class="toc1" id="part1"><a href="#/9781569479674_Split5#parta1">PART ONE: CHECKPOINT</a></p>
<p class="toc1" id="part2"><span href="#/9781569479674_Split11_1#parta2" title="Link target outside of Sample">PART TWO: TOWER</span></p>
<p class="toc1" id="part3"><span href="#/9781569479674_Split25_1#parta3" title="Link target outside of Sample">PART THREE: CONVOY</span></p>
<p class="toc1" id="part4"><span href="#/9781569479674_Split51_1#parta4" title="Link target outside of Sample">PART FOUR: WAR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?300a3f8c